enum BusinessAreaEnum {
    TRADE_AND_SERVICES = "TRADE_AND_SERVICES",
    INDUSTRY = "INDUSTRY",
    STATE_ADMINISTRATION = "STATE_ADMINISTRATION",
    AGRICULTURE = "AGRICULTURE",
    GAMBLING = "GAMBLING",
    CRYPTOCURRENCY_TRADING = "CRYPTOCURRENCY_TRADING",
    PRECIOUS_METAL_TRADING = "PRECIOUS_METAL_TRADING",
    ARMS_TRADING = "ARMS_TRADING",
    LEGAL_SERVICES = "LEGAL_SERVICES",
}

export default BusinessAreaEnum;
